import { render, staticRenderFns } from "./memberLayOut.vue?vue&type=template&id=bc700fde"
import script from "./memberLayOut.vue?vue&type=script&lang=js"
export * from "./memberLayOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports